/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ maxSizeMB: NonNullable<unknown> }} Errors_Filesizetoolarge_Single3Inputs */

const en_errors_filesizetoolarge_single3 = /** @type {(inputs: Errors_Filesizetoolarge_Single3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The file is too large. Maximum file size is ${i?.maxSizeMB}.`)
};

/**
* | output |
* | --- |
* | "The file is too large. Maximum file size is {maxSizeMB}." |
*
* @param {Errors_Filesizetoolarge_Single3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const errors_filesizetoolarge_single3 = /** @type {((inputs: Errors_Filesizetoolarge_Single3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errors_Filesizetoolarge_Single3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_errors_filesizetoolarge_single3(inputs)
});
export { errors_filesizetoolarge_single3 as "errors_fileSizeTooLarge_single" }